import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { setIsLogoutDialog } from '../../redux/reducers/app'
import { selectLicense } from '../../redux/reducers/license'
import { performHaptics } from '../../utils/performHaptics'
import AppBar from '../UI/AppBar'
import BarButton from '../UI/buttons/BarButton'
import Clock from '../UI/Clock'
import PrimaryTitle from '../UI/PrimaryTitle'
import MyMenu from './MyMenu'

const MyAppBar: FC = () => {
    const license = useAppSelector(selectLicense)!

    const dispatch = useAppDispatch()

    const handlePress = () => {
        performHaptics()

        dispatch(setIsLogoutDialog(true))
    }

    return (
        <AppBar>
            <Clock style={styles.clock} />
            <PrimaryTitle style={styles.title}>{license.name}</PrimaryTitle>
            <View style={styles.buttonsContainer}>
                <MyMenu />
                <BarButton onPress={handlePress}>Odhlásit se</BarButton>
            </View>
        </AppBar>
    )
}

const styles = StyleSheet.create({
    clock: {
        marginLeft: 16,
    },
    title: {
        textAlign: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
    },
    buttonsContainer: {
        flexDirection: 'row',
        height: '100%',
        marginRight: 16,
    },
})

export default MyAppBar
